/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Field_Project_Instructions_Q1_C5Inputs */



/**
* | output |
* | --- |
* | "Research and analysis" |
*
* @param {Uno_Field_Project_Instructions_Q1_C5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_field_project_instructions_q1_c5 = /** @type {((inputs?: Uno_Field_Project_Instructions_Q1_C5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Field_Project_Instructions_Q1_C5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Recherche und Analyse")
	return /** @type {LocalizedString} */ ("Research and analysis")
});